import ExchangeSummaryTicket from './ExchangeSummaryTicket';

export default ExchangeSummaryTicket;
